import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2ae59c14&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2ae59c14&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae59c14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae59c14')) {
      api.createRecord('2ae59c14', component.options)
    } else {
      api.reload('2ae59c14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2ae59c14&scoped=true", function () {
      api.rerender('2ae59c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/bjlogin/index.vue"
export default component.exports